import { useTranslation } from 'react-i18next';
import React, { useCallback, useMemo } from 'react';
import { openNewWindow, wrapModalPromise, WrapModalProps } from 'utils';
import { Button } from '@/components/Button';
import cx from 'clsx';

import styles from './index.module.scss';

type ExternalLinkModalProps = {
  link: string;
  level: 'forbidden' | 'warning';
  description?: string;
  openCallback?: () => void;
};

export const ExternalLinkModal = (props: ExternalLinkModalProps & WrapModalProps) => {
  const { t } = useTranslation();

  const { link, hide, level, description, openCallback } = props;

  const isForbidden = useMemo(() => level === 'forbidden', [level]);
  const isWarning = useMemo(() => level === 'warning', [level]);

  const openUrl = useCallback(() => {
    openCallback && openCallback();
    openNewWindow(link, '_blank');
    hide();
  }, [hide, link, openCallback]);
  return (
    <div className={cx(styles.modalContainer, isWarning && styles.warningModal)}>
      <div className={styles.header}>
        {isForbidden
          ? t('ExternalLinkModal.fraudulent')
          : isWarning
            ? t('ExternalLinkModal.riskTItle')
            : ''}{' '}
      </div>
      <div className={styles.urlBox}>{link}</div>
      <div className={styles.desc}>
        {description ||
          (isForbidden
            ? t('ExternalLinkModal.highRish')
            : isWarning
              ? t('ExternalLinkModal.lowTraffic')
              : '')}
      </div>
      <div className={styles.footer}>
        <Button type="primary" className={cx(styles.button)} onClick={hide}>
          {t('ExternalLinkModal.12tjh4')}
        </Button>
        {isWarning ? (
          <Button
            type="default"
            className={cx(styles.button, styles.visitButton)}
            onClick={openUrl}>
            {t('ExternalLinkModal.1gczz0')}
          </Button>
        ) : null}
      </div>
    </div>
  );
};

export const openExternalLinkModal = wrapModalPromise<ExternalLinkModalProps>(ExternalLinkModal);
